import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    event: String
  }

  connect() {
    window.parent.postMessage(this.eventValue, '*');
  }
}
